import { Divider, Typography } from 'antd';
import SLPBlock from './SLPBlock';

const { Title } = Typography;


function SLParticipants(props) {

    //console.log(props.participants);

    return (
        <>
            <Divider>
                <Title level={3}>Teilnehmer</Title>
            </Divider>
            {
                props.participants.map((participants, index) => {
                    return (
                        <div key={index}>
                            <Title level={4} style={{marginTop: "40px"}}>{participants.title}</Title>
                            {
                                <p>Plattler: {participants.dance}</p>
                            }
                            <SLPBlock
                                participants={participants}
                                autoOrder={props.autoOrder}
                                onChangeOrder={props.onChangeOrder}
                            />
                        </div>
                    );
                })
            }
            {
                /*
            <Modal
                title="Startnummer ändern"
                cancelText="Abbrechen"
                okText="Ändern"
                visible={true}
            >
                <Form.Item label="Neue Startnummer">
                    <InputNumber />
                </Form.Item>
            </Modal>
                */
            }
        </>
    )

}

export default SLParticipants;